import React, { useEffect, useState } from "react";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import Axios from "axios";
import { GetMatchedcandidateList } from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from "../helpers/loadingspinner";
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const HomeViewMatchedCandidatebyId = () => {
    let query = useQuery();
    const guid = query.get("candidateID");
    const jobPostID = query.get("jobPostID");
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');

    let Guid="";
    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const roleID = localStorage.getItem("roleID")
    
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= userguid
    }
    
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [showModal, setShowModal] = useState(false);


    const GetCandidateDetails = async () => {
        const GetapiUrl = `${GetMatchedcandidateList.APIURL}?CandidateID=${guid}&JobPostID=${jobPostID}`;

        try {
            const result = await Axios.get(GetapiUrl);
            setCandidateDetails(result.data[0]);
        } catch (error) {
            console.error("Error fetching candidate details:", error);
        }
    };
    const handleVideoClick = (videoURL) => {
        setCurrentVideoUrl(videoURL);
        setShowModal(true);
      };

    useEffect(() => {
        GetCandidateDetails();
    }, []);
   
    return (
        <div>
            {candidateDetails ? (
               <div className="container-fluid"> 
               <div className='mb-3 mt-3' style={{ display: 'flex', alignItems: 'center' }}>
               <h2 style={{ color: "#00a7ac", marginLeft: '10px', marginBottom: '0', marginTop: '0' }}>Assessment Video</h2>
               </div>
               <hr />
               <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
                 <div className="row mt-2">
                   <div className="">
                                         
                     {/* {candidateDetails.assessmentLink !== null && candidateDetails.assessmentLink !== "null" && (
                       <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip-assessmentLink">Assessment Link</Tooltip>}>
                        
                           <p className="text-para"><i className="fa fa-video icons"></i> <a href="#!" style={{fontSize:18}}></a></p>

                       </OverlayTrigger>
                     )} */}
                   </div>
                  
                 </div>
               </div>
       
  <div style={{height:'auto'}}>
 
    <div className="iframe-container">
        <iframe 
          src={candidateDetails.assessmentLink} 
          sandbox="allow-scripts allow-same-origin" 
          className="responsive-iframe" 
          allow="autoplay"
        ></iframe>

                                                
      </div>  
  </div>
  <h2 className="mb-3 mt-5" style={{ color: "#00a7ac" }}>Questions</h2>
  {candidateDetails.questions?.map((question, index) => (
                                                        <><div>
                                                            <ul style={{ listStyle: "none" }}>
                                                                <li>
                                                                    <div className="commenttt-wrapper">
                                                                        <i className="fa fa-question icons mt-2 mr-2"></i>
                                                                        <p className="text-paraaa"> {parse(DOMPurify.sanitize(question.questionName))}</p>
                                                                    </div>
                                                                    <div className="commenttt-wrapper">
                                                                        {question.answer !== null && <><i className="fa fa-check-square icons  mt-2 mr-2"></i> <p className="text-paraaa"> {parse(DOMPurify.sanitize(question.answer))}</p></>}
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div></>
                                                ))}
     </div>
             
            ) : (
                <center><LoadingSpinner /></center>
            )}
        
        </div>
    );
};

export default HomeViewMatchedCandidatebyId;





